export const AUTH_ROUTE = "/auth";

export const SIGN_IN_ROUTE = "/auth/sign-in";
export const SIGN_UP_ROUTE = "/auth/sign-up";
export const FORGOT_PASSWORD_ROUTE = "/auth/forgot-password";
export const RESET_PASSWORD_ROUTE = "/auth/reset-password";

export const TERMS_AND_CONDITIONS_ROUTE = "/tos";

export const SIGN_IN_ACTION = {
  state: { page: "sign-in" },
  route: SIGN_IN_ROUTE,
};

export const SIGN_UP_ACTION = {
  state: { page: "sign-up" },
  route: SIGN_UP_ROUTE,
};

export const FORGOT_PASSWORD_ACTION = {
  state: { page: "forgot-password" },
  route: FORGOT_PASSWORD_ROUTE,
};

export const RESET_PASSWORD_ACTION = {
  state: { page: "reset-password" },
  route: RESET_PASSWORD_ROUTE,
};

export const ROUTE_ACTIONS = {
  [SIGN_IN_ROUTE]: SIGN_IN_ACTION,
  [SIGN_UP_ROUTE]: SIGN_UP_ACTION,
  [FORGOT_PASSWORD_ROUTE]: FORGOT_PASSWORD_ACTION,
  [RESET_PASSWORD_ROUTE]: RESET_PASSWORD_ACTION,
};
